/* Pure Essence: comportamenti del negozio (scheda Kit, galleria, carrello). Nessun tracciamento qui:
   pixel ed eventi li gestiscono le app di Shopify, che rispettano il banner dei cookie. */
(function () {
  "use strict";
  var d = document;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var json = { "Content-Type": "application/json", "Accept": "application/json" };

  function euro(cent) {
    return (cent / 100).toFixed(2).replace(".", ",") + " €";
  }

  /* ---------- scheda Kit: pacchetti, spedizione gratuita, acquisto diretto ---------- */
  var kit = d.querySelector("[data-kit]");
  if (kit) {
    var form = kit.querySelector("[data-form-kit]");
    var soglia = +kit.dataset.soglia || 0;
    var idsKit = (kit.dataset.varianti || "").split(",");
    var opzioni = kit.querySelectorAll('.p-bundle input[name="id"]');
    var bottone = kit.querySelector("[data-acquista]");
    var minimoGratis = null;
    opzioni.forEach(function (o) {
      if (!o.disabled && +o.dataset.totale >= soglia && (minimoGratis === null || +o.dataset.n < minimoGratis)) minimoGratis = +o.dataset.n;
    });

    var aggiorna = function () {
      var o = kit.querySelector('.p-bundle input[name="id"]:checked');
      if (!o) return;
      var totale = +o.dataset.totale;
      var sped = kit.querySelector('[data-dono="spedizione"]');
      if (sped) {
        var gratis = totale >= soglia;
        sped.classList.toggle("is-bloccato", !gratis);
        sped.querySelector("[data-dono-pill]").textContent = gratis ? "Gratis" : (minimoGratis ? "Con " + minimoGratis + " Kit" : "Da " + (soglia / 100) + " €");
      }
      var bt = d.querySelector("[data-barra-totale]"), bn = d.querySelector("[data-barra-nome]");
      if (bt) bt.textContent = euro(totale);
      if (bn) bn.textContent = o.dataset.nome;
      if (window.history && history.replaceState) {
        var u = new URL(location.href);
        u.searchParams.set("variant", o.value);
        history.replaceState(null, "", u.toString());
      }
    };
    opzioni.forEach(function (o) { o.addEventListener("change", aggiorna); });
    aggiorna();

    // "Compra ora": nel carrello resta un solo pacchetto Kit, poi si va dritti al checkout.
    // Se qualcosa va storto si ripiega sull'invio normale del modulo (che porta comunque al checkout).
    if (form) form.addEventListener("submit", function (e) {
      var scelta = form.querySelector('input[name="id"]:checked');
      if (!scelta || !window.fetch) return;
      e.preventDefault();
      if (bottone) { bottone.disabled = true; bottone.classList.add("is-attesa"); }
      fetch(root + "cart.js", { headers: json })
        .then(function (r) { return r.json(); })
        .then(function (carrello) {
          var togli = {};
          (carrello.items || []).forEach(function (it) { if (idsKit.indexOf(String(it.variant_id)) > -1) togli[it.key] = 0; });
          return Object.keys(togli).length
            ? fetch(root + "cart/update.js", { method: "POST", headers: json, body: JSON.stringify({ updates: togli }) })
            : null;
        })
        .then(function () {
          return fetch(root + "cart/add.js", { method: "POST", headers: json, body: JSON.stringify({ items: [{ id: +scelta.value, quantity: 1 }] }) });
        })
        .then(function (r) {
          if (!r.ok) throw new Error("add");
          location.href = root + "checkout";
        })
        .catch(function () {
          if (bottone) { bottone.disabled = false; bottone.classList.remove("is-attesa"); }
          HTMLFormElement.prototype.submit.call(form);
        });
    });

    // la barra in basso compra il pacchetto scelto
    var compraBarra = d.querySelector("[data-barra-compra]");
    if (compraBarra && form) compraBarra.addEventListener("click", function (e) {
      e.preventDefault();
      if (form.requestSubmit) form.requestSubmit(bottone || undefined);
      else kit.scrollIntoView({ behavior: "smooth" });
    });

    // la barra fissa si vede ogni volta che il bottone d'acquisto non e' a schermo: anche appena si apre
    // la pagina, se il bottone e' piu' in basso (su telefono), cosi' un tasto per comprare c'e' sempre
    if (bottone && "IntersectionObserver" in window) {
      // il bottone conta come visibile solo se si vede tutto, non se ne spunta un pezzo dal bordo
      new IntersectionObserver(function (voci) {
        d.body.classList.toggle("acquisto-visibile", voci[0].intersectionRatio > 0.95);
      }, { threshold: [0, 0.5, 0.96, 1] }).observe(bottone);
    }
  }

  /* ---------- data di spedizione: il prossimo giorno lavorativo ---------- */
  var giorni = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
  var mesi = ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"];
  var parte = new Date();
  do { parte.setDate(parte.getDate() + 1); } while (parte.getDay() === 0 || parte.getDay() === 6);
  d.querySelectorAll("[data-spedizione]").forEach(function (el) {
    el.textContent = giorni[parte.getDay()] + " " + parte.getDate() + " " + mesi[parte.getMonth()];
  });

  /* ---------- galleria: scorre col dito, con le frecce o con le miniature ---------- */
  var binario = d.getElementById("binario");
  if (binario) {
    var slide = binario.querySelectorAll(".p-slide");
    var mini = d.querySelectorAll(".p-mini");
    var corrente = 0;
    var vai = function (i) {
      i = Math.max(0, Math.min(slide.length - 1, i));
      binario.scrollTo({ left: slide[i].offsetLeft - slide[0].offsetLeft, behavior: "smooth" });
    };
    mini.forEach(function (m) { m.addEventListener("click", function () { vai(+m.dataset.vai); }); });
    d.querySelectorAll("[data-passo]").forEach(function (f) {
      f.addEventListener("click", function () { vai(corrente + (+f.dataset.passo)); });
    });
    if ("IntersectionObserver" in window) {
      var guarda = new IntersectionObserver(function (voci) {
        voci.forEach(function (v) {
          if (!v.isIntersecting) return;
          corrente = +v.target.dataset.slide;
          mini.forEach(function (m) { m.setAttribute("aria-current", +m.dataset.vai === corrente ? "true" : "false"); });
        });
      }, { root: binario, threshold: 0.6 });
      slide.forEach(function (s) { guarda.observe(s); });
    }
  }

  /* ---------- tre gesti: ogni cerchio si riempie quando entra a schermo ---------- */
  var tempo = d.querySelector(".s-tempo");
  if (tempo && "IntersectionObserver" in window && !matchMedia("(prefers-reduced-motion: reduce)").matches) {
    tempo.classList.add("is-anima");
    var osserva = new IntersectionObserver(function (voci) {
      voci.forEach(function (v) { if (v.isIntersecting) { v.target.classList.add("is-visto"); osserva.unobserve(v.target); } });
    }, { rootMargin: "0px 0px -35% 0px" });
    tempo.querySelectorAll("li").forEach(function (li) { osserva.observe(li); });
  }

  /* ---------- gallerie di sole immagini: il pallino segue la foto in vista ---------- */
  if ("IntersectionObserver" in window) {
    d.querySelectorAll(".kp-galleria").forEach(function (g) {
      var bin = g.querySelector(".kp-galleria__binario");
      var pallini = g.querySelectorAll(".kp-galleria__pallini span");
      if (!bin || !pallini.length) return;
      var foto = bin.querySelectorAll(".kp-galleria__foto");
      var io = new IntersectionObserver(function (voci) {
        voci.forEach(function (v) {
          if (!v.isIntersecting) return;
          var i = Array.prototype.indexOf.call(foto, v.target);
          pallini.forEach(function (p, j) { p.classList.toggle("is-attivo", j === i); });
        });
      }, { root: bin, threshold: 0.6 });
      foto.forEach(function (f) { io.observe(f); });
    });
  }

  /* ---------- pagina del Kit: foto e schede compaiono con calma mentre si scorre ----------
     Solo quello che all'apertura sta sotto lo schermo, cosi' nulla lampeggia; niente con "riduci movimento". */
  if (d.body.classList.contains("tpl-product-kit") && "IntersectionObserver" in window && !matchMedia("(prefers-reduced-motion: reduce)").matches) {
    var rivela = new IntersectionObserver(function (voci) {
      voci.forEach(function (v) { if (v.isIntersecting) { v.target.classList.add("is-in"); rivela.unobserve(v.target); } });
    }, { rootMargin: "0px 0px -8% 0px" });
    d.querySelectorAll(".k-cap__foto, .k-cap__foto2, .k-cap__evidenza, .k-cap__lista li, .k-cap__parte li, .v-scheda, .v-punto, .s-tempo li, .k-punti__foto, .v-gesti__foto, .kp-galleria__binario, .k-contiene .v-chiusura, .k-punti .v-chiusura").forEach(function (el) {
      if (el.getBoundingClientRect().top < innerHeight) return;
      // schede in fila: una dopo l'altra
      var fratelli = Array.prototype.filter.call(el.parentNode.children, function (c) { return c.tagName === el.tagName; });
      var i = fratelli.indexOf(el);
      if (fratelli.length > 1 && i > 0) {
        el.style.transitionDelay = (Math.min(i, 4) * 90) + "ms";
        // poi il ritardo non serve piu' (non deve rallentare l'effetto al passaggio del mouse)
        el.addEventListener("transitionend", function via() { el.style.transitionDelay = ""; el.removeEventListener("transitionend", via); });
      }
      el.classList.add("rivela");
      rivela.observe(el);
    });
  }

  /* ---------- scheda prodotto singolo: quantità ---------- */
  d.querySelectorAll("[data-qta]").forEach(function (b) {
    b.addEventListener("click", function () {
      var input = b.parentNode.querySelector('input[name="quantity"]');
      input.value = Math.max(1, (+input.value || 1) + (+b.dataset.qta));
    });
  });

  /* ---------- carrello: la quantità si aggiorna da sola ---------- */
  var carrello = d.getElementById("carrello");
  if (carrello) {
    var timer;
    carrello.querySelectorAll("[data-aggiorna]").forEach(function (i) {
      i.addEventListener("change", function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var h = d.createElement("input");
          h.type = "hidden"; h.name = "update"; h.value = "1";
          carrello.appendChild(h);
          HTMLFormElement.prototype.submit.call(carrello);
        }, 350);
      });
    });
  }

  /* ---------- "Preferenze cookie": riapre il banner di Shopify, se attivo ---------- */
  var pref = d.querySelector("[data-preferenze-cookie]");
  if (pref) {
    var prova = 0;
    (function cerca() {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === "function") {
        pref.hidden = false;
        pref.addEventListener("click", function () { window.privacyBanner.showPreferences(); });
      } else if (prova++ < 20) {
        setTimeout(cerca, 500);
      }
    })();
  }
})();
